import React, { useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Button,
  Container,
  DataGridButton,
  Title,
  UserDeleteOptionsGreen,
  UserDeleteOptionsRed,
} from "./styles";
import {
  Button as MuiButton,
  Avatar,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Snackbar,
  Alert,
  AlertColor,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { UserPermissions } from "../../../../App";

interface Props {
  userPermissions: UserPermissions;
}
const Users: React.FC<Props> = ({ userPermissions }) => {
  let { organization } = useParams();

  const [openForm, setOpenForm] = React.useState(false);
  const [formValue, setFormValue] = React.useState("");

  const handleClickOpenForm = () => {
    setOpenForm(true);
  };

  const handleCloseForm = (createUser?: boolean) => {
    setOpenForm(false);
    if (createUser) onCreateOrganizationMember();
    else setFormValue("");
  };

  const [showStatus, setShowStatus] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");
  const [statusSeverity, setStatusSeverity] =
    React.useState<AlertColor>("error");
  const handleCloseStatus = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowStatus(false);
  };

  const [userDelete, setUserDelete] = useState("");

  const columns = [
    {
      field: "username",
      headerName: "Username",
      width: 150,
      renderCell: (params: any) => (
        <>
          <Avatar
            src={params.value.photo}
            sx={{ height: "2rem", width: "2rem", marginRight: "1rem" }}
          />{" "}
          {params.value.username}
        </>
      ),
    },
    {
      field: "admin",
      headerName: "Admin",
      width: 95,
      renderCell: (params: any) => (
        <span style={{}}>
          <Checkbox
            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            color="success"
            onChange={function (event: React.ChangeEvent<HTMLInputElement>) {
              editMemberPermission({
                username: params.row.username.username,
                permission: "isAdmin",
                value: !params.value,
              });
            }}
            checked={params.value}
          />
        </span>
      ),
    },
    {
      field: "clinical",
      headerName: "Clinical",
      width: 95,
      renderCell: (params: any) => (
        <span style={{}}>
          <Checkbox
            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            color="success"
            onChange={function (event: React.ChangeEvent<HTMLInputElement>) {
              editMemberPermission({
                username: params.row.username.username,
                permission: "isClinical",
                value: !params.value,
              });
            }}
            checked={params.value}
          />
        </span>
      ),
    },
    {
      field: "developer",
      headerName: "Developer",
      width: 95,
      renderCell: (params: any) => (
        <span style={{}}>
          <Checkbox
            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            color="success"
            onChange={function (event: React.ChangeEvent<HTMLInputElement>) {
              editMemberPermission({
                username: params.row.username.username,
                permission: "isDeveloper",
                value: !params.value,
              });
            }}
            checked={params.value}
          />
        </span>
      ),
    },
    {
      field: "researcher",
      headerName: "Researcher",
      width: 95,
      renderCell: (params: any) => (
        <span style={{}}>
          <Checkbox
            sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
            color="success"
            onChange={function (event: React.ChangeEvent<HTMLInputElement>) {
              editMemberPermission({
                username: params.row.username.username,
                permission: "isResearcher",
                value: !params.value,
              });
            }}
            checked={params.value}
          />
        </span>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      width: 250,
      renderCell: (params: any) => (
        <span style={{}}>
          {userDelete === params.row.username.username ? (
            <>
              Delete?{" "}
              <UserDeleteOptionsRed
                onClick={() => {
                  deleteOrganizationMember({ username: userDelete });
                  setUserDelete("");
                }}
              >
                Yes
              </UserDeleteOptionsRed>{" "}
              <UserDeleteOptionsGreen
                onClick={() => {
                  setUserDelete("");
                }}
              >
                No
              </UserDeleteOptionsGreen>
            </>
          ) : (
            <DataGridButton
              style={{ color: "#DB3A34", border: "2px solid #DB3A34" }}
              onClick={() => {
                setUserDelete(params.row.username.username);
              }}
            >
              Delete
            </DataGridButton>
          )}
        </span>
      ),
    },
  ];

  const [tableData, setTableData] = useState([
    /**{
            id: "Zlynt",
            username: {
                username: "Zlynt",
                photo: process.env.PUBLIC_URL + "/img/demoUsers/demo4.jpg"
            },
            admin: true,
            clinical: false,
            developer: true,
            researcher: false,
            action: "View Delete"
        }**/
  ]);

  const onCreateOrganizationMember = () => {
    console.log(`User: ${formValue}, Org: ${organization}`);

    fetch("/api/v1/organization/members/add", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        organization,
        username: formValue,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          console.log("Created!");
          setStatusMsg("Organization member was added!");
          setStatusSeverity("success");
          setShowStatus(true);
          getOrganizationMembers();
        } else {
          console.log("Not created: ", data.reason);
          if (data.reason === "Unkown Error")
            setStatusMsg(
              `Organization member was not added due to an unkown error. Refresh the page and try again.`
            );
          else
            setStatusMsg(
              `Organization member was not added: ${data.reason + ""}`
            );
          setStatusSeverity("error");
          setShowStatus(true);
        }
        setFormValue("");
      });
  };

  const editMemberPermission = (params: {
    username: string;
    permission: string;
    value: boolean;
  }) => {
    console.log("To send: ", params);
    fetch("/api/v1/organization/members/edit", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: params.username,
        organization: organization,
        [params.permission]: params.value === true ? 1 : 0,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        getOrganizationMembers();
      });
  };

  const deleteOrganizationMember = (params: { username: string }) => {
    console.log("To send: ", params);
    fetch("/api/v1/organization/members/delete", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: params.username,
        organization: organization,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        getOrganizationMembers();
      });
  };

  const getOrganizationMembers = () => {
    fetch("/api/v1/organization/members/all", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        organization,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.success === true) {
          data.members = data.members.map((member: any) => {
            return {
              id: member.user.username,
              username: {
                username: member.user.username,
                photo: member.user.logo,
              },
              admin: member.isAdmin === 1 ? true : false,
              clinical: member.isClinical === 1 ? true : false,
              developer: member.isDeveloper === 1 ? true : false,
              researcher: member.isResearcher === 1 ? true : false,
              action: "View Delete",
            };
          });
          setTableData(data.members);
          setTableLoading(false);
        }
      });
  };

  const [tableLoading, setTableLoading] = useState(false);
  React.useEffect(() => {
    setTableLoading(true);
    getOrganizationMembers();

    const interval = setInterval(() => {
      getOrganizationMembers();
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Title>
        Organization Members{" "}
        <Button
          onClick={() => {
            handleClickOpenForm();
          }}
        >
          Add new user
        </Button>
      </Title>
      <Dialog open={openForm} onClose={() => handleCloseForm(false)}>
        <DialogTitle>Add a new User</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please type the username of the user that is going to be added into
            your organization
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="username"
            label="Username"
            type="text"
            fullWidth
            variant="standard"
            value={formValue}
            onChange={(ev) => setFormValue(ev.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <MuiButton onClick={() => handleCloseForm(false)}>Cancel</MuiButton>
          <MuiButton onClick={() => handleCloseForm(true)}>Add</MuiButton>
        </DialogActions>
      </Dialog>

      <div style={{ height: 500, width: "100%", paddingTop: "1rem" }}>
        <DataGrid
          style={{ fontWeight: 900, color: "rgba(55, 73, 87, 0.7)" }}
          rows={tableData}
          columns={columns}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          components={{ Toolbar: GridToolbar }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          loading={tableLoading}
        />
      </div>

      <Snackbar
        open={showStatus}
        autoHideDuration={6000}
        onClose={handleCloseStatus}
      >
        <Alert
          onClose={handleCloseStatus}
          severity={statusSeverity}
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Users;
